{
    "Target1Label": "Target 1:",
    "Target1Placeholder": "15",
    "Target2Label": "Target 2:",
    "Target2Placeholder": "30",
    "Target3Label": "Target 3:",
    "Target3Placeholder": "60",
    "Target4Label": "Target 4:",
    "Target4Placeholder": "90",
    "Target5Label": "Target 5:",
    "Target5Placeholder": "120",
    "Target6Label": "Target 6:",
    "Target6Placeholder": "300",
    "TargetUnit": "s",
    "ResetanswertargetsButtonLabel": "Reset Answer Targets",
    "ResetanswertargetsPrompt": "Are you sure you wish to reset all 6 inbound call answer duration threshold settings back to their default values?",
    "ResetanswertargetsPromptButtonConfirmLabel": "Confirm",
    "ResetanswertargetsPromptButtonCancelLabel": "Cancel",
    "NAME": "AnswerPerformance",
    "AnswerPerformance_SectionHeader": "Answer Performance",
    "AnswerPerformance_SectionPara": "You can also specifically adjust the target answer duration threshold(s), which are used by the seven \"Answered <= Xs\" style inbound answer performance statistic variants."
}